import React from "react";
import { Box, Tabs, Tab, useMediaQuery, useTheme } from "@mui/material";

const CategoryTabs = ({ menus, tabIndex, onTabChange, selectedCategory, IMAGE_BASE_URL }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const categoryImage = selectedCategory?.category?.image
    ? `${IMAGE_BASE_URL}${selectedCategory.category.image}`
    : "https://via.placeholder.com/400x120?text=No+Category+Image";

  return (
    <>
      {/* صورة المجاميع */}
      {selectedCategory && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            mt: { xs: 2, sm: 2.5, md: 3 },
            mb: { xs: 1.5, sm: 2 },
          }}
        >
          <Box
            sx={{
              width: { xs: 100, sm: 140, md: 180, lg: 220 },
              height: { xs: 100, sm: 140, md: 180, lg: 220 },
              borderRadius: "50%",
              overflow: "hidden",
              boxShadow: "0 4px 24px 0 rgba(255,61,61,0.13)",
              border: { xs: "3px solid #fffbe6", md: "4px solid #fffbe6" },
              bgcolor: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={categoryImage}
              alt={selectedCategory.category?.name || "تصنيف"}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: "50%",
                display: "block",
              }}
            />
          </Box>
        </Box>
      )}

      {/* Tabs للفئات */}
      <Box sx={{ 
        display: "flex", 
        justifyContent: "center", 
        mb: { xs: 2, sm: 3, md: 4 },
        px: { xs: 1, sm: 2 },
      }}>
        <Tabs
          value={tabIndex}
          onChange={(_, v) => onTabChange(v)}
          centered={!isMobile}
          variant={isMobile ? "scrollable" : "scrollable"}
          scrollButtons="auto"
          allowScrollButtonsMobile
          sx={{
            bgcolor: "#fff",
            borderRadius: { xs: 2, md: 3 },
            boxShadow: "0 2px 8px 0 rgba(0,0,0,0.04)",
            px: { xs: 1, sm: 2 },
            minHeight: { xs: 42, sm: 48 },
            maxWidth: "100%",
            "& .MuiTab-root": {
              fontWeight: 700,
              color: "#222",
              fontSize: { xs: 14, sm: 16, md: 18 },
              mx: { xs: 0.5, sm: 1 },
              px: { xs: 1.5, sm: 2, md: 3 },
              borderRadius: 2,
              minHeight: { xs: 42, sm: 48 },
              minWidth: { xs: 80, sm: 100 },
              transition: "color 0.2s, background 0.2s",
              "&.Mui-selected": {
                color: "#ff3d3d",
                bgcolor: "#fffbe6",
              },
            },
            "& .MuiTabs-scrollButtons": {
              width: { xs: 30, sm: 40 },
            },
          }}
          TabIndicatorProps={{
            style: { 
              background: "#ff3d3d", 
              height: isMobile ? 3 : 4, 
              borderRadius: 2 
            },
          }}
        >
          {menus.map((item) => (
            <Tab key={item.category.id} label={item.category.name} />
          ))}
        </Tabs>
      </Box>
    </>
  );
};

export default CategoryTabs;
